import React from 'react';
import TopBadges from '../TopBadges';
import Accordian from './Accordian';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToBucket, removeItemFromBucket } from '../../features/bucket/bucketSlice';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { everyDayMeals } from '../../constants';

const ItemModal = ({ isModalOpen, setIsModalOpen, data }) => {
  console.log("🚀 ~ file: ItemModal.jsx:10 ~ ItemModal ~ data:", data);

  const dispatch = useDispatch();

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const addToBucket = (data) => {
    dispatch(addItemToBucket(data));
  };
  const removeFromBucket = (data) => {
    dispatch(removeItemFromBucket(data));
  };

  const bucket = useSelector((state) => state.bucket.items);
  console.log("🚀 ~ file: ItemModal.jsx:24 ~ ItemModal ~ bucket:", bucket);

  const currentItem = everyDayMeals.find((item) => item?.id === data?.id);
  console.log("🚀 ~ file: ItemModal.jsx:26 ~ ItemModal ~ currentItem:", currentItem);

  return (
    <div>
      <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-auto">
        <div onClick={closeModal} className="fixed inset-0 bg-black opacity-50 cursor-pointer z-50"></div>
        <div className="bg-white p-4 pt-0 rounded-2xl shadow-lg w-[65%] z-50">
          <TopBadges />
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold my-2">{data?.title}</h2>
            <button onClick={closeModal} className="text-black bg-light-secondary rounded-sm hover:text-gray-800 focus:outline-none w-12 h-9 flex justify-center items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="flex flex-col-reverse w-full lg:flex-row">
          <div className="w-[65%] sm:w-full lg:w-[65%]">
              <Accordian data={data} />
            </div>
            <div className="w-[100%] lg:w-[40%] flex flex-col justify-center items-center mt-4 lg:mt-0">
              <img src={data.image} alt="modal-items" />
              <h1 className="font-semibold text-2xl">{data?.title}</h1>
              <h1 className="text-center">{data.description}</h1>
              <div className="flex justify-between items-center">
                <div className="flex justify-center gap-1 items-center">
                  <div className="border rounded-md border-light-secondary p-3">
                    <AiOutlineMinus onClick={() => removeFromBucket(currentItem)} />
                  </div>
                  <div className='text-2xl text-bold'>0</div>
                  <div className="border rounded-md border-light-secondary p-3">
                    <AiOutlinePlus onClick={() => addToBucket(currentItem)} />
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-between h-12 bg-light-secondary rounded-md text-white items-center p-3 mt-2">
                <p>Rs {data.price}</p>
                <p> ADD TO BUCKET</p>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemModal;
